
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z"}}),_c('path',{attrs:{"fill":"#000","fill-rule":"nonzero","d":"M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm4.553 5.263a1.195 1.195 0 00-1.594.087L12 10.31 9.041 7.35a1.194 1.194 0 10-1.69 1.691L10.308 12 7.35 14.959l-.087.097a1.195 1.195 0 00.087 1.594l.097.087c.47.378 1.158.349 1.594-.087L12 13.69l2.959 2.959a1.194 1.194 0 101.69-1.691L13.692 12l2.959-2.959.087-.097a1.195 1.195 0 00-.087-1.594z"}})])])
          )
        }
      }
    